import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { CustomerService } from '../customer.service';
import { ModalService } from 'src/app/services/modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Employee } from '../customer.model';
import { DepartmentService } from 'src/app/services/department.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-customer-implementationmanager-modal',
    templateUrl: './customer-implementationmanager-modal.component.html',
    styleUrl: './customer-implementationmanager-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class CustomerImplementationmanagerModalComponent {

  isEmployeesLoading: boolean = false;
  employees: Employee[] = [];
  filterEmployees: Employee[] = [];

  choosenEmployee: Employee = {} as Employee;

  searchText: string = '';

  constructor( 
    private customerService: CustomerService, 
    public modalService: ModalService,
    public activeModal: NgbActiveModal,
    private departmentService: DepartmentService,
    )
    {}

  async ngOnInit(): Promise<void> {
    this.isEmployeesLoading = true;
    this.employees = await this.customerService.getEmployees(this.departmentService.getDepartment().code);
    this.search();
    this.isEmployeesLoading = false;
  }


  search()
  {
    if (!this.searchText.trim()) 
    { 
      this.filterEmployees = [...this.employees];
      return; 
    }

    this.filterEmployees = this.employees.filter(
      x=> x.name.toString().toLowerCase().indexOf(this.searchText.toLocaleLowerCase()) > -1
      || x.departmentCode.toLowerCase().startsWith(this.searchText.toLocaleLowerCase()) 
      || x.departmentName.toLowerCase().startsWith(this.searchText.toLocaleLowerCase())
      || x.email.toLowerCase().startsWith(this.searchText.toLocaleLowerCase())
    );
    
  }   

  fastAction($event: any)
  {
      // Only one ?
      if (this.filterEmployees.length == 1)
      {
        console.log('fastAction');
      }    
  }

  chooseEmployee(employee: Employee)
  {
    this.choosenEmployee = employee;
  }

  chooseAndClose()
  {
    this.activeModal.close(this.choosenEmployee); //returnerer den valgte ressource
  }
}
